import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 50,
	height: 51,
	viewBox: "0 0 50 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M42.5801 28.2066L30.5138 36.5602L18.4474 44.9138L10.9386 50.1122C8.8899 51.5305 6.09131 50.0642 6.09131 47.5724V34.9327V16.3985V3.76115C6.09131 1.26934 8.8899 -0.196992 10.9386 1.22137L18.4474 6.41976L30.5138 14.7734L42.5801 23.127C44.3544 24.3554 44.3544 26.9782 42.5801 28.2066Z",
		fill: "#002938"
	})
});
const ForwardRef = forwardRef(SvgPlay);
export default ForwardRef;
